import React, { useState } from "react";
import JobApplicationForm from "./JobApplicationForm";
import "../css/OpenPositions.css";

const OpenPositions = () => {
  const [selectedJobTitle, setSelectedJobTitle] = useState(null);

  const jobs = [
    {
      id: 1,
      title: "English Teacher",
      location: "Nepal",
      type: "Full-Time",
      requirements: [
        "TGT (Trained Graduate Teacher) - English",
        "1+ Years Experience",
        "STeach English language and communication skills",
        "Prepare lesson plans and study materials",
      ],
      eligibility: [
        "Excellent Communication",
        "Classroom Management",
        "Passion for Teaching",
      ],
    },
    {
      id: 2,
      title: "Principal and Vice-Principal",
      location: "Nepal",
      type: "Full-Time",
      requirements: [
        "Master's Degree (Preferred B.Ed./M.Ed.)",
        "Minimum 3-5+ years of experience in educational leadership",
        "Knowledge of school operations, curriculum planning, and compliance",
        "Excellent communication and team management abilities",
      ],
      eligibility: [
        "Good communication and organizational abilities",
        "Problem Solving Skills",
        "Communication Skills",
      ],
    },
  ];

  return (
    <section id="open-positions-section" className="open-positions-section">
      <h2 className="positions-title">Open Positions</h2>
      <div className="positions-container">
        {jobs.map((job) => (
          <div key={job.id} className="job-detail-card">
            <div className="job-card-header">
              <h3>{job.title}</h3>
              <span className="job-badge">{job.type}</span>
            </div>

            <p className="job-loc">📍 {job.location}</p>

            <div className="job-info-section">
              <h4>Requirements</h4>
              <ul>
                {job.requirements.map((req, index) => (
                  <li key={index}>✓ {req}</li>
                ))}
              </ul>
            </div>

            <div className="job-info-section">
              <h4>Eligibility</h4>
              <ul>
                {job.eligibility.map((eli, index) => (
                  <li key={index}>✓ {eli}</li>
                ))}
              </ul>
            </div>

            {}
            <button
              className="apply-now-full-btn"
              onClick={() => setSelectedJobTitle(job.title)}
            >
              Apply Now
            </button>
          </div>
        ))}
      </div>

      {}
      {selectedJobTitle && (
        <JobApplicationForm
          jobTitle={selectedJobTitle}
          onClose={() => setSelectedJobTitle(null)}
        />
      )}
    </section>
  );
};

export default OpenPositions;
